import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "notificationModal",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "feedbackModalLabel"
}, " Notification Setting ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "ml-1"
}, "Notify By Text", -1)
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "ml-1"
}, "Notify By Email", -1)
const _hoisted_15 = { class: "container" }
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col-lg-10" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "mobile" }, "Mobile Number", -1)
const _hoisted_20 = {
  key: 0,
  class: "col-lg-2 d-flex align-items-center"
}
const _hoisted_21 = {
  key: 1,
  class: "row"
}
const _hoisted_22 = { class: "col-lg-5" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "fname" }, "OTP: (One Time Password)", -1)
const _hoisted_25 = { class: "col-lg-7 d-flex align-items-center" }
const _hoisted_26 = { class: "form-group otp-counter" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "otp-mini-text" }, " (An OTP Code has been sent to your mobile phone) ", -1)
const _hoisted_28 = {
  key: 2,
  class: "row"
}
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", { for: "email" }, "Email Address", -1)
const _hoisted_32 = {
  key: 1,
  class: "px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-700"
}
const _hoisted_33 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_34 = { class: "col-lg-4 d-flex align-items-center" }
const _hoisted_35 = {
  key: 3,
  class: "row"
}
const _hoisted_36 = { class: "col-lg-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createVNode("label", { for: "emailOtp" }, "OTP (Email)", -1)
const _hoisted_39 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_40 = { class: "form-group otp-counter" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "otp-mini-text" }, " (An OTP has been sent to your email) ", -1)
const _hoisted_42 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorsList,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    id: "checkboxSms",
                    name: "checkboxSms",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.notification.sms = $event)),
                    checked: _ctx.state.data.notification.sms
                  }, null, 8, ["checked"]), [
                    [_vModelCheckbox, _ctx.state.data.notification.sms]
                  ]),
                  _hoisted_12
                ]),
                _createVNode("div", _hoisted_13, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    id: "checkboxEmail",
                    name: "checkboxEmail",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.notification.email = $event)),
                    checked: _ctx.state.data.notification.email
                  }, null, 8, ["checked"]), [
                    [_vModelCheckbox, _ctx.state.data.notification.email]
                  ]),
                  _hoisted_14
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            (_ctx.state.data.notification.sms && !_ctx.state.data.phone.isVerify)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_AppPhoneNumberInput, {
                        modelValue: _ctx.state.data.registration.mobile,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.registration.mobile = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.state.ui.sendOtpButton && !_ctx.state.data.phone.isVerify)
                    ? (_openBlock(), _createBlock("div", _hoisted_20, [
                        _createVNode("button", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendOtp && _ctx.sendOtp(...args))),
                          class: 
                    _ctx.state.ui.verifyButton
                      ? 'verify-phone-num btn-primary'
                      : 'verify-phone-num btn-primary disabled'
                  
                        }, " Verify ", 2)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.ui.inputOtp)
              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        id: "otp",
                        name: "username",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.phone.otp = $event)),
                        onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkInputValue && _ctx.checkInputValue(...args))),
                        number: "",
                        onPaste: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.state.data.phone.otp]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.state.data.timeCount), 1),
                    _hoisted_27
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.notification.email && !_ctx.emailFromApi)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _hoisted_31,
                      (!_ctx.emailFromApi || !_ctx.state.data.emailVerify.isVerify)
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "email",
                            id: "email",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.registration.email = $event)),
                            placeholder: "Enter your email address"
                          }, null, 512)), [
                            [_vModelText, _ctx.state.data.registration.email]
                          ])
                        : (_openBlock(), _createBlock("span", _hoisted_32, " Verified ")),
                      (_ctx.isInvalidEmail)
                        ? (_openBlock(), _createBlock("small", _hoisted_33, " Please enter a valid email address "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_34, [
                    (!_ctx.state.data.emailVerify.isVerify)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendEmailOtp && _ctx.sendEmailOtp(...args))),
                          disabled: !_ctx.hasValidEmail,
                          class: "verify-phone-num btn-primary"
                        }, " Verify ", 8, ["disabled"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.ui.inputEmailOtp)
              ? (_openBlock(), _createBlock("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        id: "emailOtp",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.emailVerify.otp = $event)),
                        onKeyup: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.checkEmailOtp && _ctx.checkEmailOtp(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.state.data.emailVerify.otp]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _createVNode("div", _hoisted_40, _toDisplayString(_ctx.state.data.timeCount), 1),
                    _hoisted_41
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_42, [
            _createVNode("button", {
              type: "button",
              class: "btn default-btn",
              disabled: 
                _ctx.state.ui.isPostLoading.updateUserNotification ||
                (_ctx.state.data.notification.sms && !_ctx.state.data.phone.isVerify) ||
                (_ctx.state.data.notification.email &&
                  !_ctx.state.data.emailVerify.isVerify)
              ,
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.updateUserNotification && _ctx.updateUserNotification(...args)))
            }, _toDisplayString(_ctx.state.ui.isPostLoading.updateUserNotification
                  ? "Loading..."
                  : "Submit"), 9, ["disabled"])
          ])
        ])
      ])
    ])
  ]))
}